import React, { FC, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import PageWithHeader from '@app/components/PageWithHeader';
import PageHeader from '@app/components/header/PageHeader';
import useLoadable from '@app/hooks/loadable/useLoadable';
import useInfraStores from '@app/hooks/useInfraStores';
import MorteeMode from '@mortee/morteeMode';
import { getOrganizationSetup } from '@mortee/services/organizationSetupServices';
import OrganizationSetupCards from '@mortee/routes/organizationSetup/OrganizationSetupCards';

const OrganizationSetupPage: FC = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { navigationStore } = useInfraStores<MorteeMode>();
  const [organizationSetup] = useLoadable(() => getOrganizationSetup(organizationId), [organizationId]);

  const renderContent = (): ReactNode => {
    if (organizationSetup.isRejected()) {
      return <div data-testid='organization-setup-error'>Cannot get the organization setup.</div>;
    }

    if (!organizationSetup.isResolved()) {
      return <div data-testid='organization-setup-loading'>Loading…</div>;
    }

    return <OrganizationSetupCards organizationSetup={organizationSetup.result} />;
  };

  return (
    <PageWithHeader
      width='full'
      header={
        <PageHeader backButtonTo={navigationStore.generateOrganizationSetupListLink()}>
          {organizationSetup.result?.organizationName ?? 'Organization Setup'}
        </PageHeader>
      }
    >
      {renderContent()}
    </PageWithHeader>
  );
};

export default OrganizationSetupPage;
